import { csttFacadeApi } from '../csttFacadeApi';
var updateUserSetting = function (key, value) { return csttFacadeApi.put("/csttfacade/user/v1/setting", null, { params: { key: key, value: value } }); };
var changeUserRole = function (role) { return csttFacadeApi.put("/csttfacade/user/v1/updaterole", null, { params: { role: role } }); };
var getRoles = function () { return csttFacadeApi.get('/csttfacade/user/v1/roles'); };
var callCsttFacadeApis = function (apiName, setApiResponse, setApiLoader, apiParams) {
    var getProfileInfo = function () { return csttFacadeApi.get('/csttfacade/user/v1/profile'); };
    switch (apiName) {
        case 'getProfileInfo':
            setApiLoader({ loading: true, error: false });
            getProfileInfo().then(function (response) {
                setApiResponse(response.data);
                setApiLoader({ loading: false, error: false });
            })
                .catch(function (error) {
                console.log('getProfileInfo: ', error);
                setApiLoader({ loading: false, error: true, errorMessage: error.toString() });
            });
            break;
        case 'getRoles':
            setApiLoader({ loading: true, error: false });
            getRoles().then(function (response) {
                setApiResponse(response.data);
                setApiLoader({ loading: false, error: false });
            })
                .catch(function (error) {
                setApiLoader({ loading: false, error: true, errorMessage: error.toString() });
            });
            break;
        case 'changeUserRole':
            setApiLoader({ loading: true, error: false });
            changeUserRole(apiParams[0]).then(function (response) {
                setApiResponse(response.data);
                setApiLoader({ loading: false, error: false });
            })
                .catch(function (error) {
                setApiLoader({ loading: false, error: true, errorMessage: error.toString() });
            });
            break;
        case 'updateUserSetting':
            setApiLoader({ loading: true, error: false });
            updateUserSetting(apiParams[0], apiParams[1]).then(function (response) {
                setApiResponse(response.data);
                setApiLoader({ loading: false, error: false });
            })
                .catch(function (error) {
                setApiLoader({ loading: false, error: true, errorMessage: error.toString() });
            });
            break;
        default: ;
    }
};
export { callCsttFacadeApis, updateUserSetting, changeUserRole, getRoles };
